import styled from 'styled-components';

import { IdentityDocumentType } from '@dreryk/egabinet-patient-published-language-api';

import { useTranslate } from '@dreryk/react-common';

import { getIdentityDocumentSelectType } from '../../../identityDocument/IdentityDocumentTypeField';
import { identityDocumentTranslationKeys } from '../../../translations';

const StyledIdentityDocumentText = styled.span`
   word-break: break-word;
`;
StyledIdentityDocumentText.displayName = 'StyledIdentityDocumentText';

type IdentityDocumentTextProps = {
   readonly documentType: string;
   readonly documentValue: string;
};

export const getDocumentTypeTranslation = (documentType: IdentityDocumentType): string => {
   return identityDocumentTranslationKeys.identityDocumentType.typeName[getIdentityDocumentSelectType(documentType)];
};

export const IdentityDocumentText = ({ documentType, documentValue }: IdentityDocumentTextProps): JSX.Element => {
   const translate = useTranslate();
   return (
      <StyledIdentityDocumentText>
         {`${translate(getDocumentTypeTranslation(documentType as IdentityDocumentType))}: ${documentValue}`}
      </StyledIdentityDocumentText>
   );
};
